import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { apiService } from 'services/base.service';

import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { PrepRequestType } from 'models/prep-request.model';
import PrepItemMenu from '../prep-item-menu';
import RequestDetailsWrapper from 'components/base/request-details-wrapper';
import ActivityIndicator from 'components/base/loader/activityIndicator';
import { ArrowDownIcon } from 'cokitchen-icons';
import { useLocation } from 'react-router-dom';
import RequestStatusTag from 'components/base/request-status-tag';

const ReceivePrepItems = () => {
  const { pathname } = useLocation();
  const isKitchenRoute = pathname.includes('kitchen');

  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState<Record<number, boolean>>({});

  const { id } = useParams();
  const [request, setRequest] = useState<PrepRequestType>({} as PrepRequestType);

  useEffect(() => {
    getRequestDetails();
  }, []);

  const toggleDetails = (index: number) => {
    setShowDetails((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const getRequestDetails = async (showloading = true) => {
    if (showloading) {
      setLoading(true);
    }
    try {
      const res: any = await apiService.get(`prep-kitchen-request/${id}`, { version: 'v2' });
      setRequest(res.data.data);
    } catch (e: any) {
      console.log(e, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <RequestDetailsWrapper
      codeId={request?.code}
      status={request?.status}
      header='Update request'
      subHeader='Update item as received or returned once vendor delivers'>
      <div className='px-4'>
        <div className='flex flex-col gap-2'>
          {loading ? (
            <div className='flex items-center justify-center w-full min-h-[200px]'>
              <ActivityIndicator />
            </div>
          ) : (
            request?.items?.map((data, index) => {
              return (
                <div key={index}>
                  <div className='flex flex-col md:flex-row justify-between border-b border-b-[#EAEBEB] bg-[#F7F7F7E5] px-4 py-4 md:py-6 gap-4 md:gap-6 items-start md:items-center rounded'>
                    <div className='font-medium w-full md:w-auto text-sm'>
                      <div className='flex items-center md:gap-8 gap-2 mb-2'>
                        <p className=' font-semibold  text-lg text-[#2E3031] capitalize'>
                          {data.ingredient.name}
                        </p>
                        <RequestStatusTag status={data.status} />
                      </div>
                      <div className='flex flex-wrap items-center gap-2 text-sm md:text-base'>
                        <p>
                          {data.quantity_requested} {data.ingredient.unit_type} requested
                        </p>
                        <span className='hidden md:blockw-2 h-2 rounded-full bg-[#D9D9D9]'></span>
                        <p className='text-[#33A5FF]'>
                          {data.quantity_sent ?? 0} {data.ingredient.unit_type ?? 'items'} sent
                        </p>
                      </div>
                    </div>
                    <div className='flex gap-3 w-full md:w-auto justify-end items-center md:justify-start'>
                      {data?.batches?.length === 0 ? (
                        <div className='flex justify-center h-64 items-center'>
                          <p> Oops, no items have been sent yet </p>
                        </div>
                      ) : (
                        !isKitchenRoute &&
                        (request.status === ENUM_REQUEST_STATUS.SENT ||
                          request.status === ENUM_REQUEST_STATUS.RECEIVED) && (
                          <div className='p-1 rounded'>
                            {
                              <PrepItemMenu
                                ids={data.id}
                                status={data.status}
                                onSuccess={() => getRequestDetails(false)}
                              />
                            }
                          </div>
                        )
                      )}

                      <div
                        className={`${
                          showDetails[index] ? 'rotate-180' : ''
                        } cursor-pointer bg-gray-1 hover:bg-gray-2  rounded-full border-[#EAEBEB]`}
                        onClick={() => toggleDetails(index)}>
                        {<ArrowDownIcon className='w-6 h-6' />}
                      </div>
                    </div>
                  </div>
                  {showDetails[index] && data.prep_item_ingredients.length > 0 && (
                    <ul className='flex flex-col gap-2 px-2 mt-2'>
                      {data.prep_item_ingredients.map((item, itemIndex) => (
                        <li key={itemIndex} className='flex gap-3 items-center'>
                          <p className='font-medium text-[#2E3031] '>{item.ingredient.name}</p>
                          <div className='bg-[#6F7376] w-1 h-1 rounded-full' />
                          <p className='font-medium text-[#6F7376] '>
                            {item.quantity_requested ?? 0} {item.ingredient.unit_type ?? 'portions'}{' '}
                            requested
                          </p>
                          <div className='bg-[#6F7376] w-1 h-1 rounded-full' />
                          <p className='font-medium text-[#33A5FF]'>
                            {item.quantity_sent ?? 0} {item.ingredient.unit_type ?? 'porions'} sent
                          </p>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </RequestDetailsWrapper>
  );
};

export default ReceivePrepItems;
